// @flow
import type { Element } from 'react';

import React from 'react';
import { Form } from 'reactstrap';
import {
  ANCHORAGE_DUCTILITY,
  ID_COMPONENT_CLASS,
  IS_CALCULATED,
  CALCULATION_TYPE,
} from '@hbrisk/sp3-risk-model-support/components/app/attributes/names/index.js';
import { fieldsByName } from '@hbrisk/sp3-risk-model-support/components/form/fields/index.js';
import type { SectionComponentProps } from '#components/pages/Components/Component/sections/support/types/componentPagerSection';
import {
  Field,
  Col,
  FormGroup,
  Fieldset,
} from '#components/pages/Components/support/form/index.js';

import NextButton from '../support/buttons/NextButton.jsx';
import BackButton from '../support/buttons/BackButton.jsx';

const CapacityCalculation = ({
  onBack,
  onNext,
  readOnly,
}: SectionComponentProps): Element<'div'> => (
  <Form noValidate>
    <Fieldset>
      <legend>Capacity Calculation</legend>
      <FormGroup fields={[IS_CALCULATED]} row>
        <Col lg="6">
          <Field field={fieldsByName[IS_CALCULATED]} readOnly={readOnly} />
        </Col>
      </FormGroup>
      <FormGroup fields={[CALCULATION_TYPE]} row>
        <Col lg="6">
          <Field field={fieldsByName[CALCULATION_TYPE]} readOnly={readOnly} />
        </Col>
      </FormGroup>
      <FormGroup fields={[ANCHORAGE_DUCTILITY]} row>
        <Col lg="6">
          <Field field={fieldsByName[ANCHORAGE_DUCTILITY]} readOnly={readOnly} />
        </Col>
      </FormGroup>
      <FormGroup fields={[ID_COMPONENT_CLASS]} row>
        <Col lg="6">
          <Field field={fieldsByName[ID_COMPONENT_CLASS]} readOnly={readOnly} />
        </Col>
      </FormGroup>
    </Fieldset>
    <BackButton onClick={onBack} />
    <NextButton onClick={onNext} />
  </Form>
);

export default CapacityCalculation;
